import type { ReactNode } from 'react';
import styles from './RunStepDetailField.module.css';

/** Shows one labeled value in a run step's detail. */
export function RunStepDetailField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className={styles.field}>
      <div className={styles.fieldLabel}>{label}</div>
      <div className={styles.fieldValue}>{children}</div>
    </div>
  );
}

/** Stacks a run step's detail fields. */
export function RunStepDetailFieldList({ children }: { children: ReactNode }) {
  return <div className={styles.fieldList}>{children}</div>;
}
